import { MagazineRifleIcon } from './MagazineRifleIcon';

/**
 * author: Andrew Laws
 * id 70793340-E8F2-43A0-8AB1-0DAB70CC8B9A
 * name magazine-rifle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magazine-rifle.svg
 * tags
 */
export const AmmunitionRifleIcon = MagazineRifleIcon;
export default AmmunitionRifleIcon